import { render, staticRenderFns } from "./nearby_doctor.vue?vue&type=template&id=1533de03&"
import script from "./nearby_doctor.vue?vue&type=script&lang=js&"
export * from "./nearby_doctor.vue?vue&type=script&lang=js&"
import style0 from "./nearby_doctor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports